import script from "./QuestionsSelectionComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionsSelectionComponent.vue?vue&type=script&setup=true&lang=js"

import "./QuestionsSelectionComponent.vue?vue&type=style&index=0&id=c23a8190&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c23a8190"]])

export default __exports__